import React from 'react'
import i18next from 'i18next'
import { Map } from 'immutable'

import Button from './Button'
import Paginator from './Paginator'
import UnitDetailsWopi360AddModalFormRow from './UnitDetailsWopi360AddModalFormRow'

export default class UnitDetailsWopi360AddModaForm extends React.PureComponent {
  state = {
    selectedTargetUuids: Map()
  }

  handlePagination = page => {
    this.getWopi360Targets(page)
  }

  handleSelectTarget = uuid => {
    if (this.state.selectedTargetUuids.has(uuid)) {
      this.setState({ selectedTargetUuids: this.state.selectedTargetUuids.delete(uuid) })
    } else {
      this.setState({ selectedTargetUuids: this.state.selectedTargetUuids.set(uuid, true) })
    }
  }

  handleSubmit = () => {
    this.props.onSubmit(this.state.selectedTargetUuids.keySeq().toJS())
  }

  render() {
    const { selectedTargetUuids } = this.state
    const { targets, pagination, unitTargets, isDisabled, onPaginate } = this.props

    return (
      <div>
        <table className="table">
          <thead>
            <tr>
              <th style={{ textAlign: 'center', width: 80 }}>{i18next.t('select')}</th>
              <th>{i18next.t('target_person_and_role')}</th>
              <th>{i18next.t('organisation')}</th>
            </tr>
          </thead>

          <tbody>
            {targets.map(target => (
              <UnitDetailsWopi360AddModalFormRow
                key={target.uuid}
                target={target}
                isSelected={selectedTargetUuids.has(target.uuid)}
                isDisabled={unitTargets.some(ut => ut.uuid === target.uuid)}
                onSelect={this.handleSelectTarget}
              />
            ))}
          </tbody>
        </table>

        {pagination && (
          <Paginator
            totalCount={pagination.totalCount}
            page={pagination.page}
            limit={pagination.limit}
            onPaginate={onPaginate}
          />
        )}

        <Button onClick={this.handleSubmit} text={i18next.t('attach')} disabled={isDisabled} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitDetailsWopi360AddModalForm.js